import React, { useContext } from 'react';
import Select from 'react-select';
import get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { updateVulnGeneral } from 'store/ManageGeneral/actions';
import { basicSelect } from 'Common/styles/style';
import { capitalize } from 'utils/stringUtils';
import { easeOfResolution } from 'Screens/Constants';
import Wrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ActionBar/components/EaseOfResolutionPicker/styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { ThemeContext } from 'Context';

const EaseOfResolutionPicker = () => {
  const dispatch = useDispatch();
  const vuln = useSelector(selectVulnDetail);

  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const vulnEaseOfResolution = get(vuln, 'easeofresolution', '');
  const value = {
    label: capitalize(vulnEaseOfResolution) || 'Ease of resolution',
    value: vulnEaseOfResolution || 'Ease of resolution'
  };

  const { themeStyles } = useContext(ThemeContext);

  return (
    <Wrapper isDisabled={ !canUpdate }>
      <Select
        styles={ basicSelect(themeStyles) }
        isSearchable={ false }
        isDisabled={ !canUpdate }
        value={ value }
        onChange={ (e) => dispatch(updateVulnGeneral(vuln, 'easeofresolution', e.value)) }
        options={ easeOfResolution.map((element) => ({ label: element.desc, value: element.name })) }
      />
    </Wrapper>
  );
};

export default EaseOfResolutionPicker;
